import { getIdTokenString } from '$shared/auth/auth-service';

export async function refreshAuthorizationHeader(): Promise<string> {
  try {
    // this automatically refreshes the accessToken and idToken if tokens are expired and a valid refreshToken is present
    return `Bearer ${await getIdTokenString()}`;
  } catch (error) {
    // eslint-disable-next-line no-console -- maybe useful for debugging
    console.error(error);
    return Promise.reject(error);
  }
}
